import { numberFilters } from '../../utils/number-filters';

import {
  PRICE_DESC,
  PRICE_ASC,
  BEST_PRICE,
  LOWEST_PRICE,
  ORDER_PARAM,
} from './constants';

interface SortByFilterProps {
  routeState: string;
  href: string;
}

const sortByFilter = (props: SortByFilterProps) => {
  const { routeState, href } = props;
  const numberFilter = numberFilters(href);

  const descPrice = routeState?.includes(PRICE_DESC);
  const ascPrice = routeState?.includes(PRICE_ASC);

  if (!descPrice && !ascPrice) {
    return href;
  }

  const newUrl = new URL(href);

  const newPriceOrder = descPrice ? BEST_PRICE : LOWEST_PRICE;

  const existingOrderPattern = new RegExp(`(${BEST_PRICE}|${LOWEST_PRICE})`);

  if (existingOrderPattern.test(href)) {
    return href.replace(existingOrderPattern, newPriceOrder);
  }

  if (numberFilter === 0) {
    return `${href}/${newPriceOrder}`;
  }

  newUrl.searchParams.set(ORDER_PARAM, newPriceOrder);

  return newUrl.toString();
};

export default sortByFilter;
